import { render } from "./FormDesigner.vue?vue&type=template&id=3eb9cc97&scoped=true"
import script from "./FormDesigner.vue?vue&type=script&lang=js"
export * from "./FormDesigner.vue?vue&type=script&lang=js"

import "./FormDesigner.vue?vue&type=style&index=0&id=3eb9cc97&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb9cc97"]])

export default __exports__